<template>
  <div class="course-ad-container">
    <div class="course-ad">
      <div class="course-ad-content">
        <div class="course-ad-banner"></div>
        <img class="course-ad-img" :src="pic" alt="课程介绍" />
      </div>
      <div class="course-ad-fixed">
        <div class="course-ad-buy-tab">
          <div class="course-ad-buy-title">咕比美术AI课（体验课）</div>
          <div class="course-ad-buy-subtitle">
            专业美院名师授课（适合3~8岁）
          </div>
          <div class="course-ad-buy-msg">
            <div class="course-ad-buy-text">
              <div class="course-ad-buy-text-item">
                <span class="course-ad-tab-title">包邮配：</span
                >价值199元实体画具
              </div>
              <div class="course-ad-buy-text-item">
                <span class="course-ad-tab-title">免费赠：</span
                >14天专业社群辅导
              </div>
              <div class="course-ad-buy-text-item">
                <span class="course-ad-tab-title">抢购中：</span
                >名额有限，抢先占位
              </div>
              <div class="course-ad-buy-price">
                ￥<span class="course-ad-current-price">29/</span>10节
                <span class="course-ad-origin-price">官方价￥399</span>
              </div>
            </div>
            <div class="course-ad-buy-qrcode">
              <div class="course-ad-qrcode-img">
                <vue-qrcode
                  :value="qrcodeLink"
                  class="qrcode-img"
                  :margin="qrcodeMargin"
                />
              </div>
              <div class="course-ad-qrcode-tips">扫码抢购</div>
            </div>
          </div>
        </div>
        <div class="course-step-tab">
          <div class="course-step-title">简单3步，开启孩子学习之旅：</div>
          <div class="course-step-box">
            <div class="course-step-box-left">
              <div class="course-step-line"></div>
              <div class="course-step-item buy"></div>
              <div class="course-step-item download"></div>
              <div class="course-step-item tv"></div>
            </div>
            <div class="course-step-box-right">
              <div class="course-step-box-title">购买课程</div>
              <div class="course-step-box-desc">扫描上方二维码，购买课程</div>
              <div class="course-step-box-title">下载客户端</div>
              <div class="course-step-box-desc middle">
                成功购买课程后，请及时下载【咕比AI课】APP，<br />
                购课手机号即为登陆账号
              </div>
              <div class="course-step-box-title">轻松上课</div>
              <div class="course-step-box-desc">
                在APP中查看课程，课程支持回看
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './index.scss';
</style>

<script>
import pic from './img/introduction-mini.png'
import VueQrcode from 'vue-qrcode'
import { getExperienceCourseBaseUrl } from '../../util'

export default {
  name: 'CourseAd',
  components: {
    VueQrcode,
  },
  data: function () {
    return {
      pic,
      qrcodeLink:
        getExperienceCourseBaseUrl() +
        '?bd_vid=' +
        (this.$route.query.bd_vid || '') +
        '&channelId=' +
        (this.$route.query.channelId || ''),
      qrcodeMargin: 0,
    }
  },
}
</script>
